<template>
  <div class="rank-list">
    <el-tabs v-model="rank" @tab-click="handleClick">
      <el-tab-pane label="红包排行" name="redPage"></el-tab-pane>
      <el-tab-pane label="粉丝排行" name="fans"></el-tab-pane>
      <el-tab-pane label="基本设置" name="settings"></el-tab-pane>
    </el-tabs>

    <fans v-if="rank == 'fans'"> </fans>
    <redPage v-else-if="rank == 'redPage'"> </redPage>
    <setting v-else> </setting>
  </div>
</template>

<script>
import fans from "./fans.vue";
import redPage from "./redpage.vue";
import setting from "./setting.vue";

export default {
  data() {
    return {
      rank: "redPage",
      sheareList: "commission",
    };
  },
  components: {
    fans,
    redPage,
    setting,
  },
  created() {},
  methods: {
    handleClick(tab) {
      let tarbarname = tab.name;
      this.name = tarbarname;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/plus/rank/index.vue